import { render, staticRenderFns } from "./ChannelsSectionBox.vue?vue&type=template&id=6f6b233d&scoped=true&"
import script from "./ChannelsSectionBox.vue?vue&type=script&lang=js&"
export * from "./ChannelsSectionBox.vue?vue&type=script&lang=js&"
import style0 from "./ChannelsSectionBox.vue?vue&type=style&index=0&id=6f6b233d&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f6b233d",
  null
  
)

export default component.exports